/* eslint i18next/no-literal-string: 0 */
import React, { useState } from 'react'
import { ui } from '@linqpal/components'
import { Image, View } from 'react-native'
import { Divider, MenuItem } from '@ui-kitten/components'
import { LockIcon } from '../assets/icons'

const TaxIdImage = require('./GeneralApplication/Application/images/TaxId.png')

const {
  BtScreen,
  BtSidebar,
  BtModal,
  Col,
  Row,
  BtInput,
  BtSelect,
  BtDropdown,
  BtButton,
  Spacer,
  BtText,
  BtDatePicker,
  BtSecuredInput,
  BtCheckBox,
  BtMonthYearPicker,
  BtRadioButton,
  BtProgress,
  BtStatus,
  BtAlert,
  BtTitle,
} = ui

export default () => {
  const [sidebar, showSidebar] = useState<boolean>(false)
  const [modal, showModal] = useState<boolean>(false)

  return (
    <BtScreen
      title={'Title'}
      leftTitleAction={
        <BtButton size={'small'} onPress={() => showSidebar(true)}>
          Sidebar
        </BtButton>
      }
      rightTitleAction={
        <View style={{ flexDirection: 'row' }}>
          <BtButton
            size={'small'}
            appearance={'ghost'}
            onPress={() => showModal(true)}
          >
            Modal
          </BtButton>

          <Spacer width={20} height={0} />
          <BtButton size={'small'} appearance={'outline'} status={'danger'}>
            action 3
          </BtButton>
        </View>
      }
    >
      <Row>
        <Col sm={6} md={4} xs={12}>
          <Buttons />
          <Alerts />
        </Col>
        <Col sm={6} md={4} xs={12}>
          <Inputs />
        </Col>
        <Col sm={6} md={4} xs={12}>
          <OtherComponents />
        </Col>
      </Row>
      <Sidebar visible={sidebar} onClose={() => showSidebar(false)} />
      <Modal visible={modal} onClose={() => showModal(false)} />
    </BtScreen>
  )
}

const Sidebar = ({ visible, onClose }) => {
  return (
    <BtSidebar
      visible={visible}
      title={'Title'}
      onClose={onClose}
      footer={
        <View style={{ flexDirection: 'row' }}>
          <BtButton size={'small'} appearance={'ghost'} onPress={onClose}>
            action 2
          </BtButton>
          <View style={{ flex: 1 }} />
          <BtButton
            size={'small'}
            appearance={'outline'}
            status={'danger'}
            onPress={onClose}
          >
            action 3
          </BtButton>
        </View>
      }
    >
      <BtButton appearance={'ghost'}>ghost</BtButton>
      <Spacer height={5} />
      <BtButton status={'danger'}>danger</BtButton>
      <Spacer height={5} />
      <BtButton status={'warning'}>warning</BtButton>
    </BtSidebar>
  )
}

const Buttons = () => (
  <>
    <BtText>Buttons</BtText>
    <BtButton>default</BtButton>
    <Spacer height={5} />
    <BtButton appearance={'outline'}>outline</BtButton>
    <Spacer height={5} />
    <BtButton appearance={'ghost'}>ghost</BtButton>
    <Spacer height={5} />
    <BtButton status={'danger'}>danger</BtButton>
    <Spacer height={5} />
    <BtButton status={'warning'}>warning</BtButton>
  </>
)

const OPTIONS = [
  { value: 1, label: 'option 1' },
  { value: 2, label: 'option 2' },
  { value: 3, label: 'option 3' },
]

const OPTIONS_PRIMITIVE = ['option 1', 'option 2', 'option 3']

const Inputs = () => {
  const [value, setValue] = useState('')
  const [monthYear, setMonthYear] = useState('11/2021')

  return (
    <>
      <View style={{ position: 'relative' }}>
        <View
          style={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            zIndex: 1000,
          }}
        >
          <Image
            source={
              TaxIdImage.hasOwnProperty('default')
                ? TaxIdImage.default
                : TaxIdImage
            }
            style={{
              width: 310,
              height: 48,
              borderBottomRightRadius: 5,
              borderTopRightRadius: 5,
            }}
            resizeMode="contain"
          />
          <View
            style={{
              position: 'absolute',
              height: '100%',
              alignItems: 'center',
              right: 10,
              flexDirection: 'row',
              justifyContent: 'center',
              marginRight: 28,
            }}
          >
            <LockIcon />
            <BtText
              style={{
                color: 'white',
                fontWeight: '600',
                fontSize: 16,
                marginLeft: 15,
              }}
            >
              Encrypted & Secure Data
            </BtText>
          </View>
        </View>
        <BtSecuredInput
          label={'asdasdsa'}
          placeholder={'asdasdasd'}
          onLayout={(e) => console.log(e)}
        />
      </View>

      <BtInput label={'input'} value={value} onChangeText={setValue} />
      <BtInput
        label={'input success'}
        status={'success'}
        value={value}
        onChangeText={setValue}
      />
      <BtInput
        label={'input warning'}
        status={'warning'}
        value={value}
        onChangeText={setValue}
      />
      <BtSecuredInput
        label={'secured input'}
        value={value}
        onChangeText={setValue}
      />
      <BtInput
        label={'input with error'}
        errorText={'here will be the error text'}
        value={value}
        onChangeText={setValue}
      />
      <BtSelect
        label={'select'}
        options={OPTIONS}
        keyName="value"
        labelName="label"
      />
      <BtSelect
        label={'select flat array'}
        primitiveArray
        options={OPTIONS_PRIMITIVE}
        status={'warning'}
      />
      <BtSelect
        label={'multiselect'}
        options={OPTIONS_PRIMITIVE}
        multiSelect
        primitiveArray
      />
      <BtDatePicker label={'date picker'} />
      <BtMonthYearPicker
        label={'month year picker'}
        value={monthYear}
        onChange={setMonthYear}
      />
    </>
  )
}

const Modal = ({ visible, onClose }) => {
  return (
    <BtModal
      visible={visible}
      onClose={onClose}
      title={'title'}
      footer={
        <View style={{ flexDirection: 'row' }}>
          <BtButton size={'small'} appearance={'ghost'} onPress={onClose}>
            Submit
          </BtButton>
          <View style={{ flex: 1 }} />
          <BtButton
            size={'small'}
            appearance={'outline'}
            status={'danger'}
            onPress={onClose}
          >
            Delete
          </BtButton>
        </View>
      }
    >
      <View
        style={{
          width: 350,
          height: 100,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <BtText>this is content</BtText>
      </View>
    </BtModal>
  )
}

const OtherComponents = () => {
  const [checked, setChecked] = useState(false)
  const [radio, setRadio] = useState('radio1')
  return (
    <>
      <BtCheckBox
        label={'checkbox'}
        checked={checked}
        onPress={() => setChecked(!checked)}
      />
      <BtRadioButton
        label={'radio1'}
        checked={radio === 'radio1'}
        onPress={() => setRadio('radio1')}
      />
      <BtRadioButton
        label={'radio2'}
        checked={radio === 'radio2'}
        onPress={() => setRadio('radio2')}
      />
      <Spacer />
      <Divider />
      <BtText>Progress</BtText>
      <BtProgress.Bar progress={0.6} />
      <Spacer height={10} />
      <BtProgress.Bar
        indeterminate
        borderRadius={0}
        borderWidth={0}
        height={8}
        unfilledColor="rgba(0, 153, 255, 0.2)"
        color="#0099ff"
        indeterminateAnimationDuration={1500}
      />
      <Spacer />

      <BtDropdown
        anchor={<BtButton size="small">Dropdown on button</BtButton>}
        fullWidth={true}
      >
        <MenuItem onPress={() => console.log('click')} title="View more" />
        <MenuItem onPress={() => console.log('click')} title="second more" />
      </BtDropdown>
      <Spacer />
      <BtDropdown anchor={<BtText>Dropdown on Text</BtText>} fullWidth={true}>
        <MenuItem onPress={() => console.log('click')} title="View more" />
        <MenuItem onPress={() => console.log('click')} title="second more" />
      </BtDropdown>
      <Spacer />
      <BtText>Statuses</BtText>
      <View
        style={{
          justifyContent: 'space-between',
          flexDirection: 'row',
          width: '100%',
          flexWrap: 'wrap',
        }}
      >
        <BtStatus type="EXPIRED" />
        <BtStatus type="PAID" />
        <BtStatus type="PENDING" />
        <BtStatus type="DRAFT" />
        <BtStatus type="CANCELLED" />
        <BtStatus type="FAILED" />
        <BtStatus type="PLACED" />
        <BtStatus type="DISMISSED" />
      </View>
    </>
  )
}

const Alerts = () => {
  const [visible, setVisible] = useState(true)
  return (
    <View>
      <Spacer />
      <BtTitle>Alert</BtTitle>
      <BtButton onPress={() => setVisible(!visible)}>alert</BtButton>
      <BtAlert
        visible={visible}
        onClose={() => setVisible(!visible)}
        title={'Are you sure you want to continue?'}
        width={500}
        type={'danger'}
        buttons={[
          {
            label: 'Delete the project',
            onPress: () => setVisible(!visible),
            appearance: 'outline',
            status: 'danger',
          },
          { label: 'Go back', onPress: () => setVisible(!visible) },
        ]}
      >
        <BtText
          size={18}
          style={{ lineHeight: 26, textAlign: 'center' }}
          weight={'500'}
        >
          The GoodTrace project and all information about it will be permanently
          deleted without the possibility of recovery
        </BtText>
      </BtAlert>
    </View>
  )
}
